export default __webpack_public_path__ + "static/media/Swift-Sport.4f4d1bf2.png";